import { GeoDsMeta } from "./meta-data.model";

export class Project extends GeoDsMeta {
    ParentId: string;
    Designation: string;
    State: string;
    StartDate: Date;
    EndDate: Date;
    Description: string;
    Label?: string;

    constructor(data) {
        super();
        Object.assign(this, data);
    }
}